import { useUser } from '@clerk/nextjs';
import { useQuery } from '@tanstack/react-query';
import { Query } from '@web/constants/query';
import axios from 'axios';

type ApiResponse = {
  success: boolean;
  token: string | null;
};

export function useHubspotVisitorApiToken() {
  const { user } = useUser();
  return useQuery({
    queryKey: [Query.AppKeys['hubspot-visitor-api-token'], { userId: user?.id }],
    refetchOnWindowFocus: false,
    staleTime: Infinity,
    retry: false,
    queryFn: async () => {
      const resp = await axios.get<ApiResponse>(`${process.env.NEXT_PUBLIC_API_APP_ENDPOINT}/fetch-hubspot-token`, {
        params: {
          email: user?.emailAddresses[0].emailAddress,
          firstName: user?.firstName,
          lastName: user?.lastName,
        },
      });

      window.hsConversationsSettings = {
        identificationEmail: user?.emailAddresses[0].emailAddress,
        identificationToken: resp.data.token,
      };

      return resp.data.token;
    },
  });
}
